export const scrollToSection = (sectionId: string) => {
  const targetId = sectionId.replace('#', '').replace('/', '');
  const element = document.getElementById(targetId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};
